import jwtDecode from 'jwt-decode';

export const checkTokenExpiration = (token) => {
  let isTokenExpired = true;
  try {
    const decoded = jwtDecode(token);
    const exp = decoded?.exp ? Number(decoded?.exp) : null;
    const now = Math.floor(new Date().getTime() / 1000);
    if (exp && now < exp) {
      isTokenExpired = false;
    }
  } catch (e) {
    console.log('Error parsing jwt token');
  }
  return isTokenExpired;
};
